import ClientsSideFilter from "../../users/components/ClientsSideFilter";
import { useFormsContext } from "../../../context/forms/FormsContextProvider";
import FormsHeader from "./FormsHeader";
import FormsMain from "./FormsScreen/FormsMain";

function MainPage() {
  const { clearDaySummaryFormFilter } = useFormsContext();

  return (
    <div className="w-full h-full min-h-0 overflow-hidden">
      <div className="w-full h-full bg-grayLightBg flex gap-1">
        <ClientsSideFilter
          clearDaySummaryFormFilter={clearDaySummaryFormFilter}
        />

        <div className="flex-1 flex flex-col gap-1 min-h-0 overflow-y-auto">
          {/* Header */}
          <FormsHeader />

          <FormsMain />
        </div>
      </div>
    </div>
  );
}

export default MainPage;
